module.exports = {
  // nftContractAddress: "0x4340d4182b5Cc54D5Aed65E9b6fE17Fb4cB8729A", //testnet
  // nftMarketPlaceAddress: "0x9B33fE5b0100F406F4dce6eff49cAc2063E64586", //testnet
  // singhCoinAddress: "0xEF4Bd5C378B6fBa34B2549dAF2E0997eB9EC2dDb", // testnet
  // campaignRewardAddress: "0x89564F00260D6BAb814A8C643A13A9F6AefbF533", //testnet

  nftContractAddress: "0x498EC86Cb04baB9773cceB098Fff140B13C4B99A", //mainnet
  nftMarketPlaceAddress: "0x7721d85a5c71eb9d78d7a4c0c3f931988052e8e9", //mainet
  singhCoinAddress: "0x867B96B33B2c13CC8cB78A9aA95420c6cD42C4c6", // mainnet

  campaignRewardAddress: "0x89564F00260D6BAb814A8C643A13A9F6AefbF533", //mainet

  // ticketPlatformAddress: "0x345843bEFA1a5E0bbE679f2C704cC6067d3e47bC",
  // chainId: 56,
  // usdtAddress: "0x55d398326f99059fF775485246999027B3197955",
  // bnbAddress: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
};
